export function coachingTracks(state) {
    return state.coaching_tracks;
}

export function dropIns(state) {
  return state.drop_ins;
}

export function upcomingEvent(state) {
    return state.upcoming_event;
}

export function upcomingEvents(state) {
    return state.homePageData;
}

export function surveyCards(state) {
  return state.survey_cards;
}
